import styled from 'styled-components';

export const CategoryPreviewContainer = styled.div`
  margin-top: 70px;

`;

